/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import * as CryptoJS from 'crypto-js';
import 'rxjs/add/operator/map';
import { deepCopy } from 'ionic-angular/util/util';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { EnvVariables } from '../../../app/environment-variables/environment-variables.token';
import { SessionProvider } from '../../../providers/session';
import { InstrumentHubProvider } from '../../../providers/serverHubs/instrument';

@Injectable()
export class Trading_OrderStore {
  public params: any;
  public isServerPush = false;
  /// *** Data
  public order: any = {};
  public balance: any = {};
  public instrument: any = {};
  constructor(
    // *** System
    private events: Events,
    private storage: Storage,
    private http: Http,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private session: SessionProvider,
    private instrumentHubProvider: InstrumentHubProvider) {
  }

  /// *** Charger l'ordre
  public load(isRefresh: boolean = false) {
    return new Promise((resolve, reject) => {
      if (isRefresh)
        this.reset();
      let order = {};
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let requestParams = new URLSearchParams();
      requestParams.append('IsNew', this.params.isNew ? 'true' : 'false');
      requestParams.append('OrderID', this.params.orderID ? this.params.orderID : '0');
      requestParams.append('OrderSide', this.params.orderSide ? this.params.orderSide : '0');
      let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
      this.http.get(this.envVariables.tradingOrderApiEndpoint, options).map(res => res.json()).subscribe(
        (data) => {
          order = data;
          if (this.params.isNew) {
            order['CustomerID'] = this.params.account.CustomerID;
            order['AccountID'] = this.params.account.AccountID;
            order['ISINCode'] = this.params.iSINCode;
          }
          else {
            this.params.account = this.session.accounts.find((account) => {
              return account.AccountID == order['AccountID'];
            });
            this.params.iSINCode = order['ISINCode'];
          }
          // Portfolio
          this.loadPortfolio(isRefresh).then(
            (data) => {
              if (this.params.isNew)
                order['Price'] = data['instrument'].Price ? data['instrument'].Price :
                  this.params.orderSide == 1 ? data['instrument'].LowerThreshold : data['instrument'].UpperThreshold;
              this.order = order;
              this.balance = data['balance'];
              this.instrument = data['instrument'];
              this._eventsSub();
              resolve();
            },
            (error) => { reject(); }
          );
        },
        (error) => {
          this.globals.showCommunicationError(this.toastCtrl, error);
          reject();
        });
    });
  }

  // *** Charger le portfeuille
  public loadPortfolio(isRefresh: boolean = false) {
    return new Promise((resolve, reject) => {
      if (!isRefresh)
        this.resetPortfolio();
      let portfolio = {
        balance: {},
        instrument: {},
      };
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let requestParams = new URLSearchParams();
      requestParams.append('CustomerID', this.params.account.CustomerID);
      requestParams.append('AccountID', this.params.account.AccountID);
      requestParams.append('ContactID', this.session.data.contactID ? this.session.data.contactID : '0');
      requestParams.append('BalanceDate', new Date().toISOString());
      let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
      this.http.get(this.envVariables.account_accountBalance_url, options).map(res => res.json()).subscribe(
        (data) => {
          portfolio.balance = data;
          // InstrumentPosition
          let requestParams = new URLSearchParams();
          requestParams.append('CustomerID', this.params.account.CustomerID);
          requestParams.append('AccountID', this.params.account.AccountID);
          requestParams.append('ISINCode', this.params.iSINCode);
          requestParams.append('BalanceDate', new Date().toISOString());
          let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
          this.http.get(this.envVariables.account_accountInstrumentPosition_url, options).map(res => res.json()).subscribe(
            (data) => {
              portfolio.instrument = data;
              resolve(portfolio);
            },
            (error) => {
              this.globals.showCommunicationError(this.toastCtrl, error);
              reject(portfolio);
            });
        },
        (error) => {
          this.globals.showCommunicationError(this.toastCtrl, error);
          reject(portfolio);
        });
    });
  }

  // *** Remise à zéro des informations de l'ordre
  public reset() {
    this.order = {};
    this.resetPortfolio();
  }

  // *** Remise à zéro des informations du portefeuille
  public resetPortfolio() {
    this.balance = {};
    this.instrument = {};
    this._eventsUnsub();
  }

  // *** S'inscrire aux évènements liés à l'ordre
  private _eventsSub() {
    try {
      this.instrumentHubProvider.subscribe(this.params.iSINCode);
      // On 'updateInstrumentTrade'
      this.events.subscribe('InstrumentHubProvider.updateInstrumentTrade', (instrumentData: any, tradeData: any) => {
        try {
          this.isServerPush = true;
          this.instrument.Price = instrumentData.LastPrice;
          this.instrument.PriceVariation = instrumentData.LastPriceVariation;
          this.instrument.PriceVariationSide = instrumentData.LastPriceVariationSide;
          this.instrument.StockValue = instrumentData.LastPrice * this.instrument.Stock;
          this.instrument.ProfitLosses = instrumentData.LastPrice - this.instrument.WeightedAverageCost;
          this.instrument.ProfitLossesRate = this.instrument.WeightedAverageCost == 0 ? 100 : (this.instrument.ProfitLosses / this.instrument.WeightedAverageCost) * 100;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateInstrumentState'
      this.events.subscribe('InstrumentHubProvider.updateInstrumentState', (instrumentData: any) => {
        try {
          this.isServerPush = true;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
        }
        catch (error) {
          this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** S'inscrire aux évènements liés à l'ordre
  private _eventsUnsub() {
    try {
      this.events.unsubscribe('InstrumentHubProvider.updateInstrumentTrade');
      this.events.unsubscribe('InstrumentHubProvider.updateInstrumentState');
      this.events.publish('InstrumentHubProvider.abord');
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/trading/order/order.store.ts